function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M6.527.316C2.927.316 0 3.29 0 6.947v10.106c0 3.657 2.927 6.631 6.527 6.631h9.946c3.6 0 6.527-2.974 6.527-6.631V6.947C23 3.29 20.073.316 16.473.316H6.527zm0 1.895h9.946c2.599 0 4.662 2.096 4.662 4.736v10.106c0 2.64-2.063 4.736-4.662 4.736H6.527c-2.599 0-4.662-2.096-4.662-4.736V6.947c0-2.64 2.063-4.736 4.662-4.736zm11.19 1.894c-.687 0-1.244.566-1.244 1.263 0 .698.557 1.264 1.243 1.264.687 0 1.243-.566 1.243-1.264 0-.697-.556-1.263-1.243-1.263zM11.5 5.685c-3.422 0-6.216 2.838-6.216 6.315 0 3.477 2.794 6.316 6.216 6.316s6.216-2.84 6.216-6.316c0-3.477-2.794-6.316-6.216-6.316zm0 1.894c2.414 0 4.351 1.968 4.351 4.421 0 2.453-1.937 4.421-4.351 4.421-2.414 0-4.351-1.968-4.351-4.421 0-2.453 1.937-4.421 4.351-4.421z"
});

var SvgEroskiFooter2Instagram = function SvgEroskiFooter2Instagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroskiFooter2Instagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroski-footer2-instagram.0d71b2bd.svg";
export { ForwardRef as ReactComponent };